import { t } from "i18next";
import { isEmpty, startCase } from "lodash";
import moment from "moment";
import React, { useState } from "react";
import { DayPicker } from "react-day-picker";
import "react-day-picker/dist/style.css";
import AuthContext from "../../context/AuthContext";
import { useContextSelector } from "use-context-selector";
const RescueFilter = ({ setFilter, filter, getData, setShow, show }) => {
    const lang = useContextSelector(AuthContext, (ctx) => {
    return ctx.lang;
  });
  console.log(lang,'lang')
  return (
    <mcd-tab-items>
      <div
        _ngcontent-serverapp-c2684251700
        className="search-checkbox-group check-group ng-tns-c2684251700-125 ng-star-inserted"
      >
        <ul _ngcontent-serverapp-c2684251700 className="ng-tns-c2684251700-125">
          {timeRanges?.map((res) => {
            return (
              <li
                onClick={() => {
                  if (res?.name == "Optional Date") {
                    setShow(true);
                    setFilter((prev) => {
                      return {
                        ...prev,
                        limit: res?.limit,
                        range: res?.key,
                      };
                    });
                  } else {
                    setFilter((prev) => {
                      return {
                        ...prev,
                        startDate: res?.getDays()?.startDate,
                        endDate: res?.getDays()?.endDate,
                        limit: res?.limit,
                        range: res?.key,
                      };
                    });
                  }
                }}
                _ngcontent-serverapp-c2684251700
                className="ng-tns-c2684251700-125 ng-star-inserted"
              >
                <input
                  _ngcontent-serverapp-c2684251700
                  className="ng-tns-c2684251700-125"
                  type="checkbox"
                  checked={filter?.limit == res?.limit}
                />
                <label
                  _ngcontent-serverapp-c2684251700
                  className="ng-tns-c2684251700-125"
                >
                  <span
                    _ngcontent-serverapp-c2684251700
                    className="ng-tns-c2684251700-125"
                  >
                    {lang === "bn" ? res?.nameBn : res?.name}
                  </span>
                  <i
                    _ngcontent-serverapp-c2684251700
                    className="ng-tns-c2684251700-125"
                    style={{
                      "background-image": `url("/assets/Other/check.svg")`,
                    }}
                  />
                </label>
              </li>
            );
          })}
        </ul>
      </div>
    </mcd-tab-items>
  );
};

export default RescueFilter;

const timeRanges = [
  {
    name: "Today",
    key:"today",
    getDays: () => ({
      startDate: moment().format("YYYY-MM-DD"),
      endDate: moment().format("YYYY-MM-DD"),
    }),
    limit: "0%",
    nameBn:"আজ",
  },

  {
    name: "Yesterday",
    key:"yesterday",
    getDays: () => ({
      startDate: moment().subtract(1, "days").format("YYYY-MM-DD"),
      endDate: moment().format("YYYY-MM-DD"),
    }),
    limit: "100%",
    nameBn:"গতকাল",
  },
  {
    name: "Last 7 days",
    key:"last7days",
    getDays: () => ({
      startDate: moment().subtract(6, "days").format("YYYY-MM-DD"),
      endDate: moment().format("YYYY-MM-DD"),
    }),
    limit: "200%",
    nameBn:"গত ৭ দিন",
  },
  {
    name: "Optional Date",
     key:"custom",
    getDays: () => ({
      startDate: moment().subtract(29, "days").format("YYYY-MM-DD"),
      endDate: moment().format("YYYY-MM-DD"),
    }),
    limit: "300%",
    nameBn:"ঐচ্ছিক তারিখ",
  },
];
